module.exports = __webpack_public_path__ + "img/02.6446bef6.png";